<!--声音-->
<template>
  <div class="voice-box fs18 cr">
    <div class="flex ac jb">
      <p class="bold">口播声音</p>
      <div>
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList">
          <el-button size="small" type="primary">上传声音</el-button>
        </el-upload>
      </div>
    </div>
    <div class="flex ac fw mt15">
      <div class="every-voice flex ac">
        <div class="card-img"  @mouseover="handleMouse" @mouseleave="handleMouseOut" @click="handlePlay">
          <img src="http://www.123lipsync.cn/html/base/images/voice/default.png" alt="">
          <div class="hover-box icon-player playing" v-if="mouseState">
            <div class="play-pause-btn">
              <i class="el-icon-video-play" v-if="palyState==1" style="color: #ffffff;font-size: 25px"></i>
              <i class="el-icon-video-pause" v-if="palyState==2"  style="color: #ffffff;font-size: 25px"></i>
              <img class="playing-box"  v-if="palyState==3" src="../assets/pcImages/voice-playing.gif">
            </div>
          </div>
        </div>
        <div>
          <p class="pp4">标准女主播</p>
          <p class="pp5">00:18</p>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: '',
    computed: {
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    data() {
      return {
        mouseState: false,
        palyState: 1,
      }
    },
    created() {
    },
    methods: {
      handleMouse() {
        this.mouseState = true
      },
      handleMouseOut() {
        if(this.palyState != 3){
          this.mouseState = false
        }
      },
      handlePlay() {
        this.mouseState = true
        if(this.palyState==1){
          this.palyState = 3
        }else if(this.palyState==3){
          this.palyState =1
        }
      },
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
    },
  }
</script>

<style lang="scss" scoped>
  .voice-box {
    background-color: #fff;
    box-shadow: 0 4px 12px 4px #0000000d;
    box-sizing: border-box;
    width: 100%;
    padding: 24px;
    height: calc(100vh - 95px - 50px);
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    border-radius: 12px;
  }
  .every-voice {
    cursor: pointer;
    position: relative;
    width: 360px;
    display: flex;
    padding: 8px;
    background: #fff;
    border: 1px solid #e2e6ff;
    border-radius: 6px;
    gap: 12px;
    height: 82px;

    .card-img {
      position: relative;
      width: 60px;
      height: 60px;
      border-radius: 8px;

      img{
        width: 100%;
        height: 100%;
        object-fit: fill;
        border-radius: 8px;
      }
      .hover-box{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        text-align: center;
        background: rgba(0, 0, 0, .5);
        border-radius: 8px;
        cursor: pointer;
        justify-content: center;
        align-items: center;
        .play-pause-btn{
          margin-top: 16px;
          .playing-box{
            width: 30px;
            height: 18px;
          }
        }
      }
    }

    .pp4 {
      font-size: 14px;
      color: #000;
      line-height: 24px;
      font-weight: 500;
      margin-bottom: 5px;
    }
    .pp5{
      font-size: 12px;
      font-weight: 400;
      color: #aaaab5;
    }
    .all-tags {
      .every-tag {
        font-size: 12px;
        color: #5b647a;
        letter-spacing: 0;
        text-align: center;
        line-height: 20px;
        font-weight: 400;
        background: #edeef7;
        border-radius: 4px;
        padding: 0 4px;
        white-space: nowrap;
        margin-right: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/voice.vue